import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type FreshdeskProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const Freshdesk = ({ size = 24, width, height, alt = '', style, ...props }: FreshdeskProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      version: '1.2',
      baseProfile: 'tiny-ps',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'matrix(0.01286174 0 0 0.01286174 2.00000000 2.00000000)',
        },
        [
          h(
            'g',
            {
            },
            [
              h(
                'path',
                {
                  fill: '#9b65c3',
                  d: 'M9.12 894C31.91 1058.11 109.41 1208.55 227.93 1327.07L492.33 1062.67C492.33 784.6 638.2 529.32 879.81 388L9.12 894Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#9b65c3',
                  d: 'M492.33 1062.67C355.57 1062.67 223.37 1026.2 104.85 957.82C72.94 939.59 41.03 916.8 9.12 894C31.91 1058.11 109.41 1208.55 227.93 1327.07L492.33 1062.67Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#be63c5',
                  d: 'M492.33 1062.67L227.93 1327.07C346.45 1445.59 496.89 1523.09 661 1545.88L1162.44 675.19C1025.68 912.24 770.4 1062.67 492.33 1062.67L492.33 1062.67Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#bf63c6',
                  d: 'M597.18 1450.15C528.8 1331.63 492.33 1199.43 492.33 1062.67L227.93 1327.07C346.45 1445.59 496.89 1523.09 661 1545.88C638.2 1513.97 615.41 1482.06 597.18 1450.15L597.18 1450.15Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#3278b1',
                  d: 'M1481.54 41.55L879.81 388C638.2 524.76 346.45 524.76 104.85 388C36.47 506.52 0 643.28 0 780.04C0 816.51 4.56 857.54 9.12 894C41.03 916.8 72.94 939.59 104.85 957.82C223.37 1026.2 355.57 1062.67 492.33 1062.67L1495.22 59.78C1490.66 55.22 1486.1 50.66 1481.54 41.55L1481.54 41.55Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#3278b2',
                  d: 'M104.85 957.82C223.37 1026.2 355.57 1062.67 492.33 1062.67C492.33 784.6 638.2 529.32 879.81 388L9.12 889.45C41.03 916.8 72.94 939.59 104.85 957.82L104.85 957.82Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#45a4ec',
                  d: 'M104.85 388C36.47 506.52 0 643.28 0 780.04C0 816.51 4.56 857.54 9.12 894L879.81 388C642.76 529.32 346.45 529.32 104.85 388L104.85 388Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#19bb7d',
                  d: 'M1495.22 59.78C1481.54 46.11 1472.43 36.99 1458.75 27.87C1431.4 9.64 1394.93 0.52 1363.02 0.52L774.96 0.52C496.89 0.52 241.61 150.95 104.85 388C346.45 524.76 638.2 524.76 879.81 388C638.2 524.76 492.33 784.6 492.33 1062.67C770.4 1062.67 1025.68 916.8 1167 675.19L1513.45 73.46C1504.34 68.9 1499.78 64.34 1495.22 59.78L1495.22 59.78Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#08c7fb',
                  d: 'M879.81 388L1481.54 41.55C1472.43 36.99 1467.87 27.87 1458.75 23.31L104.85 388C346.45 529.32 642.76 529.32 879.81 388Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#59f2f6',
                  d: 'M1358.46 0.52L774.96 0.52C496.89 0.52 241.61 150.95 104.85 388L1458.75 23.31C1426.84 9.64 1394.93 0.52 1358.46 0.52Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#da3757',
                  d: 'M1167 675.19L1513.45 73.46C1508.89 68.9 1504.34 64.34 1499.78 55.22L496.89 1058.11C496.89 1194.87 533.36 1327.07 601.73 1445.59C619.97 1477.5 642.76 1509.41 665.55 1541.32C702.02 1545.88 738.49 1550.44 774.96 1550.44C911.72 1550.44 1043.92 1513.97 1162.44 1445.59C1025.68 1208.55 1025.68 912.24 1167 675.19L1167 675.19Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#d33c4e',
                  d: 'M492.33 1062.67C492.33 1199.43 528.8 1331.63 597.18 1450.15C615.41 1482.06 638.2 1513.97 661 1545.88L1162.44 675.19C1025.68 912.24 770.4 1062.67 492.33 1062.67L492.33 1062.67Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#ee5a24',
                  d: 'M1167 675.19L665.55 1545.88C702.02 1550.44 738.49 1555 779.52 1555C916.28 1555 1048.48 1518.53 1167 1450.15C1025.68 1208.55 1025.68 912.24 1167 675.19L1167 675.19Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#8bdf55',
                  d: 'M1527.13 96.25C1513.45 73.46 1499.78 55.22 1481.54 41.55L879.81 388C638.2 524.76 492.33 784.6 492.33 1062.67C770.4 1062.67 1025.68 916.8 1167 675.19C1030.24 916.8 1030.24 1208.55 1167 1450.15C1404.05 1313.39 1554.48 1058.11 1554.48 784.6L1554.48 196.54C1554.48 160.07 1545.36 128.16 1527.13 96.25L1527.13 96.25Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#25c16f',
                  d: 'M1481.54 41.55L879.81 388C638.2 524.76 492.33 784.6 492.33 1062.67L1495.22 59.78C1490.66 55.22 1486.1 46.11 1481.54 41.55L1481.54 41.55Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#8bdf55',
                  d: 'M492.33 1062.67C770.4 1062.67 1025.68 916.8 1167 675.19L1513.45 73.46C1508.89 68.9 1504.34 64.34 1499.78 55.22L492.33 1062.67Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#ffbb00',
                  d: 'M1513.45 73.46L1167 675.19C1030.24 916.8 1030.24 1208.55 1167 1450.15L1531.69 96.25C1522.57 87.13 1518.01 82.57 1513.45 73.46L1513.45 73.46Z',
                },
              ),
              h(
                'path',
                {
                  fill: '#ffa800',
                  d: 'M1167 1450.15C1408.61 1313.39 1554.48 1058.11 1554.48 780.04L1554.48 196.54C1554.48 160.07 1545.36 128.16 1527.13 96.25L1167 1450.15L1167 1450.15Z',
                },
              ),
            ],
          ),
        ],
      ),
    ],
  );

export default Freshdesk;
